import { render, staticRenderFns } from "./YmHome.vue?vue&type=template&id=0c5a4359&scoped=true"
import script from "./YmHome.vue?vue&type=script&lang=js"
export * from "./YmHome.vue?vue&type=script&lang=js"
import style0 from "./YmHome.vue?vue&type=style&index=0&id=0c5a4359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a4359",
  null
  
)

export default component.exports